import React from 'react';
import { withRouter } from 'react-router-dom';
import { Form } from 'informed';
import { get } from 'lodash';
import { default as FormContainer } from '../../containers/Form';
import InputText from '../../components/inputs/InputText';
import InputSummernote from '../../components/inputs/InputSummernote';
import InputSelect from '../../components/inputs/InputSelect';
import Loading from '../../components/Loading';
import BaseCreate from '../../base/BaseCreate';
import { API_HOST } from '../../consts';
import Axios from 'axios';
import { InputCheckbox } from '../../components/inputs';
import { debounce } from 'lodash';
import Tour from 'reactour';
import IconButton from '@material-ui/core/IconButton';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

class Dados extends BaseCreate {
  api = `${API_HOST}/avaliacoes/avaliacao`;
  fields = [
    'nome',
    'nome_docente',
    'valor',
    'exame',
    'instrucoes',
    'numero_de_alternativas',
    'area_conhecimento',
    'componente_curricular',
    'tipo_aplicacao',
    'matriz_referencia',
    'habilidade',
    'candidato_anexo_reposta',
    'publico',
    'exam_type',
    'curso',
    'periodo'
  ];
  multiFields = ['tipos_item'];

  state = {
    paramsFetch: {
      cursoId: '',
      codigoId: "",
      areaConhecimento_id: '',
      disciplina_id: '',
      matriz_ref_id: '',
      periodo_id: ''
    },
    habilidadeFetch: {
      habilidadeSearch: ''
    },

    fetchingData: true,
    teste: '',
    habilidade: [],
    metadata: {},
    periodo: [],

    isTourOpen: false,
  };
  url = window.location.href;
  parts = this.url.split('/');
  tipoId = this.parts.pop();
  currentPath = 'Informações da Avaliação'


  componentDidMount() {
    this.fetchMetadata();
    this.fetchMe();
    super.componentDidMount();
    this.fetchApi({
      link: '/avaliacoes/avaliacao_tipo',
      name: 'tipo_aplicacao'
    });
    this.fetchApi({
      link: '/core/componente_curricular',
      name: 'componente_curricular'
    });
    this.fetchApi({ link: '/itens/tipo', name: 'tipos_item' });
    this.fetchApi({ link: '/core/exame', name: 'exames' });
    this.fetchApi({
      link: '/core/area_conhecimento',
      name: 'area_conhecimento'
    });
    this.fetchHabilidade();
    this.fetchMatrizReferencia();
    this.fetchCurso();
    this.fetchExamType();
    this.fetchPeriodo();
  }

  componentDidUpdate(prevPops, prevState) {
    if (prevState.paramsFetch != this.state.paramsFetch) {
      this.fetchMatrizReferencia();
      this.fetchCurso();
      this.fetchPeriodo();
      this.fetchHabilidade();
    }
    if (prevState.habilidadeFetch != this.state.habilidadeFetch) {
      this.fetchHabilidade()
    }
  }

  fetchMatrizReferencia = () => {
    const { paramsFetch } = this.state;
    const params = {
      status: 1,
      curso__id: paramsFetch.codigoId,
      areas_conhecimento__id: paramsFetch.areaConhecimento_id
    }
    Axios.get(`${API_HOST}/matriz_referencia/matriz_referencia`, { params })
      .then((response) => {
        const data = response.data;
        const matriz_referencia = data.map((x) => ({
          value: x.id,
          label: x.descricao
        }));
        this.setState({ matriz_referencia: matriz_referencia });
      })
      .catch((error) => console.error(error));
  };

  fetchHabilidade = debounce(async () => {
    const { paramsFetch, habilidadeFetch } = this.state;
    const params = {
      area_conhecimento_id: paramsFetch.areaConhecimento_id || get(this.formApi.getState().values, 'area_conhecimento'),
      etapa_id: paramsFetch.periodo_id || get(this.formApi.getState().values, 'periodo'),
      disciplina: paramsFetch.disciplina_id || get(this.formApi.getState().values, 'componente_curricular'),
      matriz_id: paramsFetch.matriz_ref_id || get(this.formApi.getState().values, 'matriz_referencia'),
      search: habilidadeFetch.habilidadeSearch
    };

    const habSelecionada = get(this.formApi.getState().values, 'habilidade')
    const habilidades = []

    await Axios.get(`${API_HOST}/matriz_referencia/habilidade`, { params }).then(
      (response) => {
        response.data.results.map((e) => {
          habilidades.push({
            value: e.id,
            label: `${e.cd_habilidade} - ${e.ds_habilidade}`
          })
        })
      }
    );

    if (habSelecionada) {
      await Axios.get(`${API_HOST}/matriz_referencia/habilidade?id=${habSelecionada}`).then(
        (response) => {
          response.data.results.map((e) => {
            habilidades.push({
              value: e.id,
              label: `${e.cd_habilidade} - ${e.ds_habilidade}`
            })
          });
        }
      );
    }

    this.setState({
      habilidade: habilidades
    })

  }, 600);

  fetchCurso = debounce((input, callback, e) => {
    var cursos = '';
    // e.map((elements)=>(cursos +=String(elements.value)+','))
    Axios.get(`${API_HOST}/core/curso`, {})
      .then((response) => {
        const data = response.data;
        const curso = []
        data.filter((mapResponse) => {
          if (mapResponse && mapResponse.oculto !== true) {
            curso.push({
              value: mapResponse.id,
              label: mapResponse.descricao,
              codigo: mapResponse.codigo
            })
          }
        })
        this.setState({
          curso: curso
        });
      })
      .catch((error) => console.error(error));
  }, 1000);

  fetchAreaConhecimento(exame) {
    const params = {
      exames: exame
    };
    Axios.get(`${API_HOST}/core/area_conhecimento`, { params }).then(
      (response) => {
        const data = response.data.results
          ? response.data.results
          : response.data;
        this.setState({
          area_conhecimento: data.map((x) => ({
            value: x.id,
            label: x.descricao
          }))
        });

        const areas_conhecimento =
          get(this.formApi.getState().values, 'areas_conhecimento') || [];
        if (this.formApi.fieldExists('areas_conhecimento')) {
          this.formApi.setValue(
            'areas_conhecimento',
            areas_conhecimento.filter(
              (x) => data.findIndex((y) => x === y.id) !== -1
            )
          );
        }
        this.callApi = true;
      }
    );
  }

  fetchExamType() {
    Axios.get(`${API_HOST}/avaliacoes/examType`)
      .then((response) => {
        this.setState({
          exam_type: response.data.map((x) => ({
            value: x.id,
            label: x.tipo
          }))
        });
      })
      .catch((response) => console.log(response.error));
  }

  fetchMe() {
    const token = localStorage.getItem('token');
    Axios.get(`${API_HOST}/login/me`, {
      headers: {
        Authorization: `JWT ${token}`
      }
    })
      .then((response) => {
        this.setState({ me: response.data });
      })
      .catch((response) => console.log(response.error));
  }
  handleSubmitCallback = (response) => {
    const { history } = this.props;
    const id = get(response, 'data.id');
    history.push(`/instrumentos-cognitivos/${id}/itens`);
  };

  get hasAlternativas() {
    let tiposHasAlternativas = {
      1: 'MULTIPLA_ESCOLHA_UNICA_RESPOSTA',
      2: 'MULTIPLA_ESCOLHA_MULTIPLAS_RESPOSTAS'
    };

    if (this.state.formState) {
      if (this.state.formState.values.hasOwnProperty('tipos_item')) {
        if (
          this.state.formState.values.tipos_item.some(
            (r) => tiposHasAlternativas[r]
          )
        ) {
          return true;
        }
      }
    }
    return false;
  }

  fetchFilterComponenteCurricular = (e) => {
    this.setState({ isLoading: true });

    if (e) {
      Axios.get(
        `${API_HOST}/core/componente_curricular/${String(e.value) + ','
        }/filter_areas`
      ).then((response) => {
        this.setState({
          isLoading: false,
          componente_curricular: response.data.map((x) => ({
            value: x.id,
            label: x.descricao
          }))
        });
      });
    }
  };

  fetchPeriodo = debounce(() => {
    const { paramsFetch } = this.state;
    paramsFetch.cursoId = get(this.formApi.getState().values, 'curso')
    if (paramsFetch.cursoId) {
      Axios
        .get(`${API_HOST}/core/periodo/${paramsFetch.cursoId}/filter_curso`)
        .then((response) => {
          const options = []
          response.data.map((mapResponse) => {
            if (mapResponse.etapa_nr && mapResponse.oculto !== true) {
              options.push({
                value: mapResponse.id,
                label: mapResponse.descricao,
              })
            }
          })
          this.setState({ periodo: options })

        })
        .catch((error) => console.error(error))
    }
    else {
      Axios
        .get(`${API_HOST}/core/periodo`, {
        })
        .then((response) => {
          const options = []
          response.data.map((mapResponse) => {
            if (mapResponse.etapa_nr) {
              options.push({
                value: mapResponse.id,
                label: mapResponse.descricao,
              })
            }
          })
          this.setState({ periodo: options })
        })
        .catch((error) => console.error(error))
    }
  }, 1000);


  render() {
    const {
      tipos_item,
      fetchingData,
      submitting,
      exames,
      componente_curricular,
      area_conhecimento,
      tipo_aplicacao,
      matriz_referencia,
      habilidade,
      curso,
      exam_type,
      periodo,
      matriz_ref_id,
      paramsFetch,
      isTourOpen
    } = this.state;
    const { isDisabled } = this.props;
    const disabled =
      this.state.me &&
      this.state.formState &&
      this.state.formState.values.criado_por &&
      this.state.formState.values.criado_por !== this.state.me.id;
    switch (this.tipoId) {
      case '1':
        this.currentPath = 'Informações da Trilha adaptativa';
        break;
      case '2':
        this.currentPath = 'Informações da Avaliação';
        break;
      case '3':
        this.currentPath = 'Informações da Atividade Processual';
        break;
      default:
        this.currentPath = 'Informações da Avaliação';
        break;
    }
    return (
      <Form
        onChange={(formState) => this.setState({ formState })}
        getApi={(formApi) => {
          this.formApi = formApi;
        }}
        onSubmit={this.handleSubmit}
      >
        {() => {
          if (fetchingData) {
            return <Loading />;
          }

          const stepsDados = [
            {
              selector: '[data-tour="form-informacao4"]',
              content: "Crie sua avaliação. Vamos lá? Siga o passo a passo e preencha os campos corretamente. "
            }
          ]

          return (
            <>
              <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}>
                <Tour
                  steps={stepsDados}
                  isOpen={isTourOpen}
                  onRequestClose={() => this.setState({ isTourOpen: false })}
                />

                <IconButton
                  onClick={() => this.setState({ isTourOpen: true })}
                >
                  <HelpOutlineIcon />
                </IconButton>
              </div>
              <div data-tour="form-informacao4">
                <FormContainer
                  title={this.currentPath}
                  next="itens"
                  onClick={this.handleNext}
                  disabled={submitting}
                >
                  <div className="row">
                    <InputText
                      col="col-sm-9"
                      disabled={isDisabled}
                      label="Título"
                      field="nome"
                      required={true}
                    />
                    <InputText
                      disabled={isDisabled}
                      col="col-sm-3"
                      label="Pontuação"
                      field="valor"
                      required={true}
                    />
                    {this.shouldDisplay('avaliacao.exam_type')&&(
                      <>
                        {isNaN(this.tipoId) && (
                          <InputSelect
                            disabled={isDisabled}
                            col="col-sm-5"
                            label="Tipo avaliação"
                            options={exam_type}
                            field="categoria"
                            required={true}
                          />
                        )}
                      </>
                    )}
                    {this.shouldDisplay('avaliacao.categoria') && (
                      <InputSelect
                        col="col-sm-6"
                        label="Categoria"
                        options={exames}
                        field="exame"
                        disabled={isDisabled}
                      />
                    )}
                    <InputSelect
                      multi
                      col="col-sm-7"
                      label="Segmento/Etapa"
                      disabled={isDisabled}
                      options={curso}
                      field="curso"
                      onChange={
                        (event) => {
                          if (event) {
                            this.setState({
                              paramsFetch: {
                                ...this.state.paramsFetch,
                                codigoId: event[0] && event[0].codigo,
                                cursoId: event[0] && event[0].value
                              }
                            })
                          }
                        }}
                    />
                    <InputSelect
                      disabled={isDisabled}
                      col="col-sm-5"
                      label="Série/Ano"
                      required={false}
                      options={periodo}
                      field="periodo"
                      onChange={
                        (event) => {
                          this.setState({
                            paramsFetch: {
                              ...this.state.paramsFetch,
                              periodo_id: event && event.value
                            }
                          })
                        }
                      }
                    />

                    <InputSelect
                      disabled={isDisabled}
                      // multi
                      col="col-sm-6"
                      label="Área do conhecimento"
                      field="area_conhecimento"
                      options={area_conhecimento}
                      onChange={(e) => {
                        this.setState({
                          paramsFetch: {
                            ...this.state.paramsFetch,
                            areaConhecimento_id: e && e.value
                          }
                        })
                        this.fetchFilterComponenteCurricular(e)
                      }
                      }
                    />
                    {(this.state.paramsFetch.cursoId == 6 || this.state.paramsFetch.cursoId == 10) ? (<></>) : (
                      <InputSelect
                        disabled={isDisabled}
                        col="col-sm-6"
                        label="Componente curricular"
                        field="componente_curricular"
                        required={false}
                        options={componente_curricular}
                        onChange={
                          (event) => {
                            this.setState({
                              paramsFetch: {
                                ...this.state.paramsFetch,
                                disciplina_id: event && event.value
                              }
                            })
                          }
                        }
                      />
                    )}

                    {this.shouldDisplay('avaliacao.matriz_referencia') && (
                      <InputSelect
                        disabled={isDisabled}
                        col="col-sm-12"
                        label="Matriz de referência"
                        field='matriz_referencia'
                        options={matriz_referencia}
                        onChange={
                          (event) => {
                            this.setState({
                              paramsFetch: {
                                ...this.state.paramsFetch,
                                matriz_ref_id: event && event.value
                              }
                            })
                          }
                        }
                      />
                    )}

                    {this.shouldDisplay('avaliacao.habilidade') && (
                      <InputSelect
                        disabled={isDisabled}
                        col="col-sm-12"
                        label="Habilidade"
                        options={habilidade}
                        field="habilidade"
                        required={false}
                        onChange={(event) => {
                          if (!event) {
                            this.setState({
                              habilidadeFetch: {
                                ...this.state.habilidadeFetch,
                                habilidadeSearch: ''
                              }
                            })
                          }
                        }}
                        onInputChange={(event) => {
                          if (event) {
                            this.setState({
                              habilidadeFetch: {
                                ...this.state.habilidadeFetch,
                                habilidadeSearch: event
                              }
                            })
                          }
                        }}
                      />
                    )}

                    <React.Fragment>
                      {this.hasAlternativas ? (
                        <InputText
                          col="col-sm-3"
                          label="Número de Alternativas"
                          field="numero_de_alternativas"
                        />
                      ) : null}
                    </React.Fragment>
                    <InputSummernote
                      disabled={isDisabled}
                      col="col-sm-12"
                      label="Instruções"
                      field="instrucoes"
                    />
                  </div>
                  {this.shouldDisplay('avaliacao.publico') && (
                    <InputCheckbox
                      disabled={isDisabled}
                      col="col-md-12 mb-3"
                      field="publico"
                      label="Tornar atividade pública?"
                    />
                  )}
                </FormContainer >
              </div>
            </>
          );
        }
        }
      </Form >
    );
  }
}

export default withRouter(Dados);
